module.exports = __webpack_public_path__ + "static/media/diet_landing.3da376be.png";